import { render, staticRenderFns } from "./TableRiskAppraisal688.vue?vue&type=template&id=4a019893&scoped=true"
import script from "./TableRiskAppraisal688.vue?vue&type=script&lang=js"
export * from "./TableRiskAppraisal688.vue?vue&type=script&lang=js"
import style0 from "./TableRiskAppraisal688.vue?vue&type=style&index=0&id=4a019893&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a019893",
  null
  
)

export default component.exports